export default __webpack_public_path__ + "static/media/KMT_Video.480ced0d.mp4";